import richTextEditor, {
  CHANGED_EVENT,
  FOCUS_EVENT,
  EXTENSION_COMMAND_EVENT,
  REMOUNT_REQUIRED_EVENT,
  RECONCILE_INLINE_MEDIA_EVENT,
  SYNC_EVENT,
  SYNCED_EVENT,
  UPDATE_EVENT,
  normalizeInlineMediaPreviews,
  normalizeTemporaryUploadReferences,
} from './components/richTextEditor'
import { copyExtensionData } from './support/editorExtensions'
import richTextEmbedConsent from './components/richTextEmbedConsent'

export { registerRichTextExtension } from './support/editorExtensions'

export {
  CHANGED_EVENT,
  FOCUS_EVENT,
  EXTENSION_COMMAND_EVENT,
  REMOUNT_REQUIRED_EVENT,
  RECONCILE_INLINE_MEDIA_EVENT,
  SYNC_EVENT,
  SYNCED_EVENT,
  UPDATE_EVENT,
}

export const initRichText = (Alpine) => {
  Alpine.data('richTextEditor', richTextEditor)
  Alpine.data('richTextEmbedConsent', richTextEmbedConsent)
}

const dispatchTo = (target, type, detail) => target.dispatchEvent(
  new CustomEvent(type, { detail })
)

/** Flushes the identified editor synchronously into its wire:model input. */
export const syncRichTextEditor = (id, target = window) =>
  dispatchTo(target, SYNC_EVENT, { id })

/** Reflects an authoritative external value and optional preview map in the identified editor. */
export const updateRichTextEditor = (id, value, previewsOrTarget, target = window) => {
  if (previewsOrTarget && typeof previewsOrTarget.dispatchEvent === 'function') {
    return dispatchTo(previewsOrTarget, UPDATE_EVENT, { id, value })
  }

  const detail = { id, value }

  if (previewsOrTarget !== undefined) {
    detail.inlineMediaPreviews = Object.fromEntries(
      normalizeInlineMediaPreviews(previewsOrTarget)
    )
  }

  return dispatchTo(target, UPDATE_EVENT, detail)
}

/** Reconciles server-confirmed temporary uploads without replacing current editor text. */
export const reconcileRichTextInlineMedia = (
  id,
  temporaryUploadReferences,
  inlineMediaPreviews = undefined,
  target = window,
) => {
  const detail = {
    id,
    temporaryUploadReferences: Object.fromEntries(
      normalizeTemporaryUploadReferences(temporaryUploadReferences)
    ),
  }

  if (inlineMediaPreviews !== undefined) {
    detail.inlineMediaPreviews = Object.fromEntries(
      normalizeInlineMediaPreviews(inlineMediaPreviews)
    )
  }

  return dispatchTo(target, RECONCILE_INLINE_MEDIA_EVENT, detail)
}

/** Moves keyboard focus to the identified editable surface. */
export const focusRichTextEditor = (id, target = window) =>
  dispatchTo(target, FOCUS_EVENT, { id })

/** Runs only a command declared by this editor's opted-in extension. */
export const runRichTextExtensionCommand = (id, extension, command, args = [], target = window) => {
  if (!Array.isArray(args)) throw new TypeError('RichText extension command arguments must be a list.')
  return dispatchTo(target, EXTENSION_COMMAND_EVENT, {
    id, extension, command, args: copyExtensionData(args),
  })
}

export default initRichText
